import { useEffect, useState } from 'react'
import _ from 'lodash'
import BreadCrumb from '../../components/BreadCrumb'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import Loader from '../../utils/loader'
import PageTitleInstaller from '../../components/PageTitleInstaller'
import Card from '../../components/Card'
import SiteForm from '../../components/SiteForm'
import { ENPHASE_INSTALLER } from '../../components/Header/constants'
import { getSessionToken, getIsInstaller } from '../../utils/helper'
import history from '../../routes/history'
import { useStyles } from './styles'
import CustomStepper from '../../components/CustomStepper'
import { Box } from '@material-ui/core'
import { applicationStatus } from '../SiteStatusInstaller/constant'
const SiteApplicationInstaller = (props) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)
  useEffect(() => {
    if (_.isEmpty(getSessionToken())) history.push('/')
    else if (getIsInstaller() === 'false') history.push('/customersupport')
  }, [])
  const [site, setSite] = useState(props?.history?.location?.state?.site)
  const applicationText = site
    ? `Edit Application For Site ID: ${site?.site_id}`
    : 'Submit New Application'
  const sequences = ['Applications', applicationText]
  return (
    <div className={classes.layout}>
      <Loader loading={loading}></Loader>
      <Header
        isSignedIn={true}
        role={ENPHASE_INSTALLER}
        setLoading={setLoading}
        selected={selected}
        setSelected={setSelected}
      ></Header>
      <BreadCrumb sequences={sequences}></BreadCrumb>
      <PageTitleInstaller
        heading={applicationText}
        hasDownloadApplicationFormButton={true}
      ></PageTitleInstaller>
      <Box className={classes.stepperContainer}>
        <CustomStepper currentStep={site && applicationStatus[site.status]} status={site && site.status} />
      </Box>
      <Card
        className={classes.cardWrapper}
        children={<SiteForm site={site} setLoading={setLoading}></SiteForm>}
      />
      <Footer></Footer>
    </div>
  )
}
export default SiteApplicationInstaller
